import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateCompatibleTemplateWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  border-top: 1px dashed ${COLORS.primary_light_blue4};
  margin-top: 16px;
  .form-container {
    padding: 0px 0px 16px 16px;

    ${responsive.MOBILE`
      padding: 0px 8px 0px 8px !important;
     `}
  }

  .add-button-container {
    padding: 16px;
    text-align: right;

    ${responsive.MOBILE`
      text-align: center;
      padding: 16px 8px 16px 8px !important;
      button {
        width: 100%;
      }
    `}
  }

  .template-header {
    margin: 18px 16px 0px 16px;
    ${responsive.MOBILE`
      margin: 16px 8px 0px 8px !important;
     `}
  }

  .country-name {
    min-width: 200px;
  }
`;
